import { api } from './client.js';

const portalFetch = (token, path, options = {}) =>
  fetch(path, {
    ...options,
    headers: {
      'X-Speaker-Token': token,
      ...(options.body ? { 'Content-Type': 'application/json' } : {}),
      ...(options.headers ?? {}),
    },
  }).then(async (r) => {
    if (!r.ok) throw new Error((await r.json().catch(() => ({}))).error ?? `Request failed (${r.status})`);
    return r.status === 204 ? null : r.json();
  });

export const portalApi = {
  // Alias for SpeakerPortalPage
  get: (token) => portalFetch(token, `/api/portal/${token}`),
  getEngagement: (token) => portalFetch(token, `/api/portal/${token}`),

  submit: (token, data) =>
    portalFetch(token, `/api/portal/${token}/submit`, {
      method: 'POST',
      body: JSON.stringify(data),
    }),

  // Alias for SpeakerPortalPage
  updateChecklistItem: (token, key, data) =>
    portalFetch(token, `/api/portal/${token}/checklist/${key}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    }),
  updateChecklist: (token, key, data) =>
    portalFetch(token, `/api/portal/${token}/checklist/${key}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    }),
};
